module.exports = __webpack_public_path__ + "static/img/h5-2.e375ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h5-2.png
// module id = Zxg2
// module chunks = 1